<template>
  <el-dialog
    :title="$t('deleteAffiliateVisit.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div align="center">
      <p>{{ $t('deleteAffiliateVisit.confirmDeleteVisitRecord') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('deleteAffiliateVisit.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAffiliateVisit">{{ $t('deleteAffiliateVisit.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAffiliateVisit } from '@/api/affiliate/affiliateVisitApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAffiliateVisit',
  data() {
    return {
      dialogVisible: false,
      currentData: null
    }
  },
  methods: {
    open(data) {
      this.currentData = data
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    async deleteAffiliateVisit() {
      try {
        const params = {
          ...this.currentData,
          shopId: getShopId()
        }
        await deleteAffiliateVisit(params)
        this.$message.success(this.$t('deleteAffiliateVisit.deleteSuccess'))
        this.close()
        this.$emit('refresh')
      } catch (error) {
        console.error('删除访问记录失败:', error)
        this.$message.error(error.message || this.$t('deleteAffiliateVisit.deleteFailed'))
      }
    }
  }
}
</script>